module.exports = __webpack_public_path__ + "img/maps-marker-deduplicate.ca3ca590.svg";